import React from 'react';
import { Card, CardContent, Box, Skeleton, alpha, useTheme } from '@mui/material';

export const CommunicationSkeleton: React.FC = () => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                marginBottom: '0.5rem !important',
                borderRadius: 2,
                justifyContent: 'flex-start !important',
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            }}
        >
            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                        color: 'text.secondary',
                        '& svg': {
                            fontSize: '1.2rem',
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                        <Skeleton variant="circular" width={20} height={20} />
                        <Skeleton variant="text" width={120} sx={{ ml: 1 }} />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
                        <Skeleton variant="circular" width={20} height={20} />
                        <Skeleton variant="text" width={100} sx={{ ml: 1 }} />
                    </Box>
                </Box>
                <Box sx={{ mt: 1 }}>
                    <Skeleton variant="text" sx={{ fontSize: '1rem', lineHeight: 1.6 }} />
                    <Skeleton variant="text" width="60%" sx={{ fontSize: '1rem', lineHeight: 1.6 }} />
                </Box>
            </CardContent>
        </Card>
    );
};
